import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { Filter } from 'utils/query_v3';

export const corporationRootFolderKey = 'corporation-root-folder';
export const locationRootFolderKey = 'location-root-folder';

const filterExp = Filter.and(
    Filter.eq('FileType', 'Folder'),
    Filter.eq('IsRootFolder', true)
);
export type UseRootFolder = Readonly<{
    groupIds?: string[];
    corporationId?: string;
    locationId?: string;
}>;
export function useRootFolder({ corporationId, locationId, groupIds }: UseRootFolder) {
    return useQuery({
        queryKey: [corporationRootFolderKey, corporationId, locationId],

        queryFn: async () => {
            if (locationId) {
                const result = await sdClient.getLocationFiles({
                    locationId,
                    groupIds,
                    filter: filterExp,
                    page: 1,
                    pageLimit: 1,
                });
                return result.Result[0];
            }
            if (corporationId) {
                const result = await sdClient.getCorporationFiles({
                    corporationId,
                    groupIds,
                    filter: filterExp,
                    page: 1,
                    pageLimit: 1,
                });
                return result.Result[0];
            }

            throw new Error('CorporationId or LocationId required to get root folder');
        },
    });
}
